import { IconPack } from '@fortawesome/fontawesome-common-types';

import { bnBunnyIcon } from './bunny-proprietary-icons/fa-bn-bunny-icon';

// FA is awesome... use 'fak' custom set and override existing font names. There is no way around fixed IconName type
export const bunnyFaIconPack: IconPack = {
  rabbit: bnBunnyIcon,
};
